import { render, staticRenderFns } from "./edit-table-dialog.vue?vue&type=template&id=04e95eb3&scoped=true&"
import script from "./edit-table-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-table-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-table-dialog.vue?vue&type=style&index=0&id=04e95eb3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e95eb3",
  null
  
)

export default component.exports